/* Guia olfativo da ANINA (seção anina-guia). Carregado só nas páginas que têm a seção. */
(() => {
  if (customElements.get('anina-guia')) return;

  const sem = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const esc = (t) =>
    String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const lista = (t) => String(t || '').split(';').map((x) => x.trim()).filter(Boolean);

  /* Grupos de aromas: cada grupo junta acordes parecidos do cadastro. */
  const GRUPOS = {
    amadeirado: ['amadeirado', 'oud', 'vetiver', 'musgo', 'terroso', 'patchouli', 'resinoso', 'cedro', 'sandalo'],
    floral: ['floral', 'floral branco', 'rosa', 'iris', 'violeta', 'empoado', 'atalcado', 'tuberosa', 'jasmim', 'aldeidico'],
    citrico: ['citrico', 'fresco', 'verde', 'aquatico', 'aromatico', 'fresco especiado', 'lavanda', 'cha', 'salgado', 'ozonico', 'marinho', 'herbal'],
    doce: ['baunilha', 'doce', 'caramelo', 'melado', 'gourmand', 'cafe', 'cacau', 'coco', 'licoroso', 'amendoado', 'mel'],
    ambar: ['ambarado', 'ambar', 'especiado', 'especiado quente', 'incenso', 'tabaco', 'canela'],
    frutado: ['frutado', 'frutas tropicais', 'cereja'],
    almiscarado: ['almiscarado', 'couro', 'animalico', 'camurca'],
  };
  const GRUPO_DE = {};
  Object.entries(GRUPOS).forEach(([g, nomes]) => nomes.forEach((n) => (GRUPO_DE[n] = g)));

  const CONCENTRACAO = {
    suave: ['eau de toilette', 'eau de cologne', 'eau fraiche'],
    equilibrio: ['eau de parfum'],
    intenso: ['parfum', 'extrait de parfum', 'extrait', 'elixir'],
  };

  const PESOS = { estacao: 2, ocasiao: 2, notas: 3, clima: 1.5, concentracao: 1.5 };

  class AninaGuia extends HTMLElement {
    connectedCallback() {
      this.telas = [...this.querySelectorAll('[data-tela]')];
      this.etapas = [...this.querySelectorAll('[data-etapa]')];
      this.barra = this.querySelector('[data-barra]');
      this.segs = [...this.querySelectorAll('[data-seg]')];
      this.contador = this.querySelector('[data-contador-texto]');
      this.continuarTexto = this.querySelector('[data-continuar-texto]');
      this.listaEl = this.querySelector('[data-lista]');
      this.resumoEl = this.querySelector('[data-resumo]');
      this.maisBtn = this.querySelector('[data-acao="mais"]');
      this.limite = parseInt(this.dataset.limite, 10) || 6;
      this.passo = -1;
      this.respostas = {};
      this.mostrando = 0;
      this.reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      try {
        const salvo = JSON.parse(localStorage.getItem('anina-guia-v1') || 'null');
        if (salvo && salvo.respostas) {
          this.salvo = salvo.respostas;
          this.querySelector('[data-acao="ultimos"]').hidden = false;
        }
      } catch (e) {}

      this.onClick = (ev) => {
        const alvo = ev.target.closest('[data-acao]');
        if (!alvo || !this.contains(alvo)) return;
        const acao = alvo.dataset.acao;
        if (acao === 'comecar') this.irPara(0);
        if (acao === 'continuar') this.avancar();
        if (acao === 'voltar') this.irPara(this.passo - 1);
        if (acao === 'refazer') this.refazer();
        if (acao === 'mais') this.renderLista(this.mostrando + this.limite);
        if (acao === 'editar') this.irPara(parseInt(alvo.dataset.passo, 10));
        if (acao === 'ultimos') {
          this.respostas = this.salvo || {};
          this.aplicarRespostasNosCampos();
          this.mostrarResultado();
        }
      };
      this.onChange = (ev) => {
        const form = ev.target.closest('[data-etapa]');
        if (!form) return;
        this.lerEtapa(form);
        if (form.dataset.tipo === 'radio' && ev.target.checked) {
          clearTimeout(this.auto);
          this.auto = setTimeout(() => this.avancar(), this.reduzir ? 0 : 320);
        }
      };
      this.onSubmit = (ev) => {
        if (ev.target.closest('[data-etapa]')) {
          ev.preventDefault();
          this.avancar();
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);

      /* Carrega a curadoria quando a seção chega perto da tela */
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (entradas) => {
            if (entradas.some((e) => e.isIntersecting)) {
              this.carregar();
              this.io.disconnect();
            }
          },
          { rootMargin: '400px 0px' }
        );
        this.io.observe(this);
      } else {
        this.carregar();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      this.io?.disconnect();
      clearTimeout(this.auto);
    }

    /* ---------- Dados ---------- */
    carregar() {
      if (this.dados) return this.dados;
      const base = this.dataset.dadosUrl;
      const pagina = (n) =>
        fetch(`${base}&page=${n}`, { credentials: 'same-origin' })
          .then((r) => r.text())
          .then((t) => {
            const i = t.indexOf('ANINA_DADOS_INICIO');
            const f = t.indexOf('ANINA_DADOS_FIM');
            return JSON.parse(t.slice(i + 'ANINA_DADOS_INICIO'.length, f));
          });
      this.dados = pagina(1)
        .then(async (p1) => {
          let itens = p1.itens;
          for (let n = 2; n <= (p1.paginas || 1); n++) itens = itens.concat((await pagina(n)).itens);
          this.perfumes = itens.filter((p) => p.av).map((p) => this.normalizar(p));
          this.atualizarContador();
          return this.perfumes;
        })
        .catch((e) => {
          console.error('[anina-guia]', e);
          this.contador.textContent = 'Não foi possível carregar a curadoria agora.';
          this.dados = null;
        });
      return this.dados;
    }

    normalizar(p) {
      const acordes = {};
      if (Array.isArray(p.aj) && p.aj.length) {
        p.aj.forEach((a) => {
          const n = sem(a.nome || a.name);
          if (n) acordes[n] = Number(a.intensidade ?? a.valor ?? 0) || 0;
        });
      } else if (p.at) {
        p.at.split(';').forEach((parte) => {
          const [nome, valor] = parte.split(':');
          const n = sem(nome);
          if (n) acordes[n] = Number(valor) || 0;
        });
      }
      const total = Object.values(acordes).reduce((a, b) => a + b, 0) || 1;
      const grupos = {};
      Object.entries(acordes).forEach(([n, v]) => {
        const g = GRUPO_DE[n] || GRUPO_DE[n.replace(/s$/, '')];
        if (g) grupos[g] = (grupos[g] || 0) + (v / total) * 100;
      });
      return {
        ...p,
        gen: sem(p.g),
        est: new Set(lista(p.e).map(sem)),
        cli: new Set(lista(p.c).map(sem)),
        oca: new Set(lista(p.o).map(sem)),
        conc: sem(p.k),
        grupos,
      };
    }

    /* ---------- Respostas ---------- */
    lerEtapa(form) {
      const nome = form.dataset.etapa;
      const marcados = [...form.querySelectorAll('input:checked')];
      this.respostas[nome] = marcados.map((i) => i.value);
      const limite = parseInt(form.dataset.limite, 10) || 0;
      if (limite) {
        const cheio = marcados.length >= limite;
        form.querySelectorAll('input').forEach((i) => {
          if (!i.checked) {
            i.disabled = cheio;
            i.closest('.anina-guia__opcao').classList.toggle('is-off', cheio);
          }
        });
      }
      this.atualizarBotao();
      this.atualizarContador();
    }

    aplicarRespostasNosCampos() {
      this.etapas.forEach((form) => {
        const valores = this.respostas[form.dataset.etapa] || [];
        form.querySelectorAll('input').forEach((i) => (i.checked = valores.includes(i.value)));
      });
    }

    /* ---------- Combinação ---------- */
    passaGenero(p) {
      const g = (this.respostas.genero || [])[0];
      if (!g || g === 'livre') return true;
      if (g === 'Unissex') return p.gen === 'unissex';
      return p.gen === sem(g) || p.gen === 'unissex';
    }

    pontuar(p) {
      const r = this.respostas;
      let soma = 0;
      let pesos = 0;
      let todas = true;
      const motivos = { notas: [], estacao: [], ocasiao: [], extra: [] };
      const rotulo = (etapa, valor) =>
        this.querySelector(`[data-etapa="${etapa}"] input[value="${CSS.escape(valor)}"]`)?.dataset.rotulo || valor;

      const conjunto = (etapa, campo) => {
        const sel = r[etapa] || [];
        if (!sel.length) return;
        const bate = sel.filter((v) => p[campo].has(sem(v)));
        const f = p[campo].size ? Math.min(1, bate.length / Math.min(sel.length, 2)) : 0.4;
        soma += PESOS[etapa] * f;
        pesos += PESOS[etapa];
        if (f < 0.5) todas = false;
        bate.forEach((v) => motivos[etapa].push(rotulo(etapa, v)));
      };
      conjunto('estacao', 'est');
      conjunto('ocasiao', 'oca');

      const notas = r.notas || [];
      if (notas.length) {
        let f = 0;
        notas.forEach((g) => {
          const v = Math.min(1, (p.grupos[g] || 0) / 40);
          f += v;
          if (v >= 0.45) motivos.notas.push({ r: rotulo('notas', g), v });
        });
        /* Aromas: 80% pela parte do perfume feita das famílias escolhidas + 20% por quantas aparecem com força, para escolher 2 ou 3 aromas não derrubar a nota */ const parte = notas.reduce((a, g) => a + (p.grupos[g] || 0), 0); const presentes = notas.filter((g) => (p.grupos[g] || 0) >= 15).length; f = notas.length * (0.8 * Math.min(1, parte / 85) + 0.2 * (presentes / notas.length)); soma += PESOS.notas * (f / notas.length);
        pesos += PESOS.notas;
        if (f / notas.length < 0.4) todas = false;
        motivos.notas.sort((x, y) => y.v - x.v);
      }

      const clima = (r.clima || [])[0];
      if (clima) {
        const f = p.cli.size ? (p.cli.has(sem(clima)) ? 1 : 0) : 0.4;
        soma += PESOS.clima * f;
        pesos += PESOS.clima;
        if (f < 0.5) todas = false;
        if (f === 1) motivos.extra.push(`Clima ${rotulo('clima', clima).toLowerCase()}`);
      }

      const conc = (r.concentracao || [])[0];
      if (conc && conc !== 'livre') {
        const f = p.conc ? (CONCENTRACAO[conc].includes(p.conc) ? 1 : 0.2) : 0.4;
        soma += PESOS.concentracao * f;
        pesos += PESOS.concentracao;
        if (f < 0.5) todas = false;
        if (f === 1) motivos.extra.push(p.k);
      }

      /* Por que combina: aromas primeiro, depois uma estação, uma ocasião e o resto */
      const lista = [
        ...motivos.notas.slice(0, 2).map((m) => m.r),
        ...motivos.estacao.slice(0, 1),
        ...motivos.ocasiao.slice(0, 1),
        ...motivos.extra,
        ...motivos.estacao.slice(1),
        ...motivos.ocasiao.slice(1),
      ];
      return { nota: pesos ? soma / pesos : 1, motivos: lista, todas };
    }

    ranquear() {
      return (this.perfumes || [])
        .filter((p) => this.passaGenero(p))
        .map((p) => ({ p, ...this.pontuar(p) }))
        .sort((a, b) => b.nota - a.nota);
    }

    atualizarContador() {
      if (!this.perfumes) return;
      const algumaResposta = ['estacao', 'ocasiao', 'notas', 'clima', 'concentracao'].some(
        (k) => (this.respostas[k] || []).filter((v) => v !== 'livre').length
      );
      const ranking = this.ranquear();
      const n = algumaResposta ? ranking.filter((x) => x.todas).length : ranking.length;
      if (n === 0) {
        this.contador.textContent = 'Nenhum combina com tudo: no fim mostramos os mais próximos';
      } else {
        this.contador.textContent =
          n === 1 ? '1 perfume combina com você até aqui' : `${n} perfumes combinam com você até aqui`;
      }
    }

    /* ---------- Navegação ---------- */
    irPara(i) {
      if (i < 0) return this.mostrarTela('intro');
      if (i >= this.etapas.length) return this.mostrarResultado();
      this.passo = i;
      this.carregar();
      const form = this.etapas[i];
      this.mostrarTela(form);
      this.barra.hidden = false;
      this.segs.forEach((s, n) => {
        s.classList.toggle('is-feito', n < i);
        s.classList.toggle('is-atual', n === i);
      });
      this.style.setProperty('--luz-x', `${15 + (i / (this.etapas.length - 1)) * 70}%`);
      this.atualizarBotao();
      this.atualizarContador();
      requestAnimationFrame(() => form.querySelector('legend')?.focus({ preventScroll: true }));
      this.rolarParaTopo();
    }

    avancar() {
      clearTimeout(this.auto);
      this.irPara(this.passo + 1);
    }

    atualizarBotao() {
      const form = this.etapas[this.passo];
      if (!form) return;
      const tem = form.querySelector('input:checked');
      const ultimo = this.passo === this.etapas.length - 1;
      this.continuarTexto.textContent = ultimo ? 'Ver meus perfumes' : tem ? 'Continuar' : 'Pular';
    }

    mostrarTela(alvo) {
      const tela = typeof alvo === 'string' ? this.querySelector(`[data-tela="${alvo}"]`) : alvo;
      this.telas.forEach((t) => {
        const on = t === tela;
        t.hidden = !on;
        t.classList.toggle('is-ativa', on);
      });
      if (tela.dataset.tela === 'intro') {
        this.barra.hidden = true;
        this.passo = -1;
        this.style.setProperty('--luz-x', '15%');
      }
    }

    rolarParaTopo() {
      const topo = this.getBoundingClientRect().top;
      if (topo < -40 || topo > window.innerHeight * 0.5) {
        this.scrollIntoView({ behavior: this.reduzir ? 'auto' : 'smooth', block: 'start' });
      }
    }

    refazer() {
      this.respostas = {};
      this.aplicarRespostasNosCampos();
      this.etapas.forEach((f) =>
        f.querySelectorAll('input').forEach((i) => {
          i.disabled = false;
          i.closest('.anina-guia__opcao').classList.remove('is-off');
        })
      );
      this.irPara(0);
    }

    /* ---------- Resultado ---------- */
    async mostrarResultado() {
      this.barra.hidden = true;
      this.passo = this.etapas.length;
      this.style.setProperty('--luz-x', '85%');
      this.mostrarTela('resultado');
      this.listaEl.innerHTML = '<li class="anina-guia__carregando">Combinando com a curadoria…</li>';
      await this.carregar();
      if (!this.perfumes) return;
      try {
        localStorage.setItem('anina-guia-v1', JSON.stringify({ respostas: this.respostas, em: Date.now() }));
        this.salvo = this.respostas;
        this.querySelector('[data-acao="ultimos"]').hidden = false;
      } catch (e) {}
      this.ranking = this.ranquear();
      const melhor = this.ranking[0]?.nota ?? 0;
      this.querySelector('[data-res-aviso]').hidden = melhor >= 0.55;
      this.renderResumo();
      this.renderLista(this.limite);
      requestAnimationFrame(() => this.querySelector('[data-res-titulo]')?.focus({ preventScroll: true }));
      this.rolarParaTopo();
    }

    renderResumo() {
      const itens = [];
      this.etapas.forEach((form, i) => {
        const valores = this.respostas[form.dataset.etapa] || [];
        if (!valores.length) return;
        const rot = valores
          .map((v) => form.querySelector(`input[value="${CSS.escape(v)}"]`)?.dataset.rotulo || v)
          .join(', ');
        itens.push(
          `<li><button type="button" class="anina-guia__chip" data-acao="editar" data-passo="${i}" aria-label="Alterar: ${esc(rot)}">${esc(rot)}<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/></svg></button></li>`
        );
      });
      this.resumoEl.innerHTML = itens.join('');
      this.resumoEl.hidden = !itens.length;
    }

    renderLista(qtd) {
      const max = Math.min(qtd, this.ranking.length, 24);
      const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: this.dataset.moeda || 'BRL' });
      const html = this.ranking
        .slice(0, max)
        .map(({ p, nota, motivos }, i) => {
          const pct = Math.max(1, Math.round(nota * 100));
          const meta = [p.k, p.vol ? `${p.vol} ml` : ''].filter(Boolean).join(' · ');
          const preco = (p.pv ? 'a partir de ' : '') + moeda.format((p.pr || 0) / 100);
          const chips = [...new Set(motivos)]
            .slice(0, 4)
            .map((m) => `<li>${esc(m)}</li>`)
            .join('');
          const comprar =
            p.vc === 1
              ? `<anina-adicionar class="anina-guia__comprar"><form action="/cart/add" method="post" data-anina-add><input type="hidden" name="id" value="${p.id}"><input type="hidden" name="quantity" value="1"><button type="submit" class="anina-guia__btn anina-guia__btn--primario anina-guia__btn--sm" aria-label="Adicionar ${esc(p.t)} à sacola"><span class="anina-combinam__add-texto">Adicionar</span></button></form></anina-adicionar>`
              : `<a class="anina-guia__btn anina-guia__btn--primario anina-guia__btn--sm" href="${esc(p.u)}">Ver opções</a>`;
          return `<li class="anina-guia__res${i < this.mostrando ? '' : ' is-nova'}" style="--i:${Math.max(0, i - this.mostrando)}">
            <a class="anina-guia__res-media" href="${esc(p.u)}" tabindex="-1" aria-hidden="true">
              ${p.img ? `<img src="${esc(p.img)}" alt="" width="480" height="480" loading="lazy">` : ''}
              <span class="anina-guia__afinidade" style="--pct:${pct}"><strong>${pct}%</strong><span>afinidade</span></span>
            </a>
            <div class="anina-guia__res-info">
              <p class="anina-guia__res-casa">${esc(p.b)}</p>
              <a class="anina-guia__res-nome" href="${esc(p.u)}">${esc(p.t)}</a>
              ${meta ? `<p class="anina-guia__res-meta">${esc(meta)}</p>` : ''}
              ${chips ? `<ul class="anina-guia__motivos" role="list" aria-label="Por que combina">${chips}</ul>` : ''}
              <div class="anina-guia__res-rodape-card">
                <p class="anina-guia__res-preco">${esc(preco)}</p>
                ${comprar}
              </div>
            </div>
          </li>`;
        })
        .join('');
      this.listaEl.innerHTML =
        html || '<li class="anina-guia__carregando">Nenhum perfume disponível com essas escolhas. Tente refazer com menos filtros.</li>';
      this.mostrando = max;
      this.maisBtn.hidden = max >= Math.min(this.ranking.length, 24);
    }
  }

  customElements.define('anina-guia', AninaGuia);
})();
